export default __webpack_public_path__ + "static/media/logoJussiVectorGreen.e005e337.svg";